import { FilterChip } from '@marqvision/shared';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { FILTER_LABEL, FILTER_LOG_LABELS } from './DynamicFilter/@constants';
import { useGetFilterParams, usePathParams } from './@hooks';

export const TestPurchaseReportFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { tp_reported_filter } = requestFilterParams;
  const { page, listingStatus } = usePathParams();

  const { amplitudeLogging } = useLogger();
  const handleChange = () => {
    const newState = !tp_reported_filter;
    if (newState) {
      amplitudeLogging('applied filter', {
        Type: FILTER_LOG_LABELS['Test Purchase report'],
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
    }
    setParams({
      tp_reported_filter: !tp_reported_filter,
    });
  };

  return (
    <FilterChip
      size={size}
      type="toggle"
      selected={!!tp_reported_filter}
      label={FILTER_LABEL['Test Purchase report']}
      onClick={handleChange}
    />
  );
};
